import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cn } from '@repo/lib/cn';
import { cva } from 'class-variance-authority';

export const toggleVariants = cva(
  "hover:bg-muted/50 aria-pressed:bg-muted outline-0 focus-visible:z-10 hover:text-foreground aria-checked:bg-muted aria-checked:text-foreground focus-visible:border-border-primary outline-focus-ring inline-flex cursor-pointer items-center justify-center rounded-sm text-sm font-medium whitespace-nowrap transition-all duration-150 focus-visible:outline-3 disabled:pointer-events-none disabled:opacity-60 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: 'border-transparent',
        outline: 'border-border-primary border focus-visible:border-border-primary-focus',
      },
      size: {
        sm: 'h-7 min-h-7 px-2 gap-1',
        md: 'h-9 min-h-9 px-2.5 gap-2',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

export function Toggle(toggleProps: ComponentProps<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>) {
  const { className, variant, size, ...props } = toggleProps;
  return <TogglePrimitive.Root data-slot={'toggle'} className={cn(toggleVariants({ variant, size, className }))} {...props} />;
}
